import { useSelector } from 'react-redux';
import { FREE } from 'self-service-api/constants/ProductLevels';
import { ownsCrmSuiteProductLevel } from '../../../selectors/ProductInventorySelectors';
import { useFTS0017orFTS0018ExperimentEffect } from '../../../utils/experiments/fts0017_fts0018';
import CurrentPlanTag from '../../common/badges/CurrentPlanTag';

/**
 * @description
 * This component is responsible for rendering only one badge at a time as we don't want to show multiple badges at once. This is similar to our BannerHierarchy component.
 */
import { jsx as _jsx } from "react/jsx-runtime";
export const FreeCardBadge = () => {
  const isCurrentPlanLevel = useSelector(state => ownsCrmSuiteProductLevel(state, {
    productLevel: FREE
  }));
  const {
    loading: isLoadingFTS0017AndFTS0018Experiment,
    variant: isInFTS0017AndFTS0018ExperimentVariant
  } = useFTS0017orFTS0018ExperimentEffect();
  const shouldShowCurrentPlanTag = isCurrentPlanLevel && !isInFTS0017AndFTS0018ExperimentVariant && !isLoadingFTS0017AndFTS0018Experiment;
  if (shouldShowCurrentPlanTag) {
    return /*#__PURE__*/_jsx(CurrentPlanTag, {
      message: 'pricing-pages-ui.merchCardsV2.badges.CURRENT_PLAN'
    });
  }
  return null;
};